'use client';

import Image from 'next/image';
import styled from 'styled-components';
import Button1 from './Button1';
import { COLORS } from '@/constants/colors';
import { TYPOGRAPHY, FONT_SIZE } from '@/constants/typography';
import { SPACING } from '@/constants/spacing';
import { BREAKPOINTS } from '@/constants/breakpoints';

const CCHero = () => {
  const handleScrollToProducts = () => {
    window.scrollTo({ top: 650, behavior: 'smooth' });
  };

  return (
    <HeroWrapper>
      <div className="img-container wrapper0">
        <div className="container-3">
          <h1 className="hero-heading-1">Air Filter Cleaner and Cleaner Oil</h1>
          <h2 className="hero-heading-2">Keep your air filter in perfect condition for lifetime usage</h2>
          <div onClick={handleScrollToProducts}>
            <Button1 text="BUY NOW" />
          </div>
        </div>
        <Image
          src="/assets/cleaner-p-800.webp"
          alt="Green Filter Cleaner Kit"
          className="filter _600"
          width={800}
          height={800}
          priority
        />
      </div>
    </HeroWrapper>
  );
};

export default CCHero;

const HeroWrapper = styled.div`
  width: 100%;

  .img-container {
    position: relative;
    min-height: 600px;
    background-repeat: no-repeat;
    background-color: ${COLORS.gray900};
  }

  .wrapper0 {
    background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.21), rgba(0, 0, 0, 0.21)),
      linear-gradient(180deg, rgba(0, 0, 0, 0.98), transparent 53%), url('/assets/cr_img0.webp');
    background-position: 0px 0px, 0px 0px, 50% 50%;
    background-size: auto, auto, cover;
  }

  .container-3 {
    position: relative;
    z-index: 9999;
    padding: ${SPACING.heroDesktop} ${SPACING.sectionSmall} ${SPACING.section};
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    max-width: 940px;
  }

  .container-3:before,
  .container-3:after {
    content: ' ';
    display: table;
  }

  .hero-heading-1 {
    ${TYPOGRAPHY.displayMD}
    color: ${COLORS.white};
    text-align: center;
    letter-spacing: 0.5px;
    padding: 0 ${SPACING.xs};
    margin-top: 0;
    margin-bottom: ${SPACING.sm};
  }

  .hero-heading-2 {
    ${TYPOGRAPHY.bodyLG}
    color: rgba(255, 255, 255, 0.95);
    text-align: center;
    letter-spacing: 0.3px;
    padding: 0 ${SPACING.xs};
    margin-top: 0;
    margin-bottom: ${SPACING.lg};
  }

  .filter._600 {
    left: -5%;
    right: auto;
    bottom: -15%;
    width: 600px;
  }

  .filter {
    position: absolute;
    right: 0%;
    bottom: -3%;
    width: 500px;
  }

  @media screen and (max-width: ${BREAKPOINTS.mobile}) {
    .img-container {
      min-height: 400px;
    }

    .container-3 {
      padding: ${SPACING.heroMobile} ${SPACING.lg} ${SPACING.xxl};
      max-width: 100%;
    }

    .hero-heading-1 {
      font-size: ${FONT_SIZE.heading.lg};
      margin-bottom: ${SPACING.xs};
    }

    .hero-heading-2 {
      font-size: ${FONT_SIZE.body.sm};
      margin-bottom: ${SPACING.md};
    }

    .filter {
      display: none !important;
    }
  }

  @media screen and (max-width: ${BREAKPOINTS.tablet}) {
    .container-3 {
      max-width: 728px;
    }
  }
`;
